export default "__VITE_ASSET__oWszinjt__"